import { createAction } from '@src/redux/helpers/createAction';
import { VALIDATE_TIN, UPDATE_TIN } from './constants';
import { updateRegistration, validateTin } from './requests';

export const updateRegistrations = (query, onSuccess, onError) => {
  return createAction({
    type: UPDATE_TIN,
    cache: false,
    payload: query,
    meta: {
      onSuccess,
      onError,
      async: updateRegistration,
    },
  });
};

export const validateTins = (query, onSuccess, onError) => {
  return createAction({
    type: VALIDATE_TIN,
    cache: false,
    payload: query,
    meta: {
      onSuccess,
      onError,
      async: validateTin,
    },
  });
};
